import { Box } from '@mui/material';

import PresentationSlides from './artwork/preso-slides.svg?react';

/** Decorative slide previews, not a preview of household data. */
export function SetupPresentationArtwork() {
  return (
    <Box
      aria-hidden="true"
      sx={{
        display: { xs: 'none', lg: 'block' },
        width: '100%',
        maxWidth: 540,
        alignSelf: 'center',
        pointerEvents: 'none',
        '& svg': { display: 'block', width: '100%', height: 'auto' },
      }}
    >
      <PresentationSlides focusable="false" />
    </Box>
  );
}
